<template>
  <div class="input-text-wrapper">
    <label v-if="label">{{ label }}</label>
    <input
      ref="input"
      v-model="model"
      :class="['input-text', { error, success}]"
      :type="inputType"
      :disabled="disabled"
      v-on="{...$listeners, input: event => $emit('input', event.target.value)}"
    >
    <span
      v-if="error"
      class="text-error"
    >{{ error }}</span>
    <span
      v-if="success"
      class="text-success"
    >{{ success }}</span>
    <div
      v-if="error.length > 0"
      class="error-icon"
    >
      <i class="icon icon-close" />
    </div>
    <div
      v-if="success.length > 0"
      class="success-icon"
    >
      <i class="icon icon-check" />
    </div>
    <div
      v-if="showEye"
      class="show-password-wrapper"
      @click="showPassword = !showPassword"
    >
      <i
        class="icon"
        :class="showPassword ?'icon-eye-off' : 'icon-eye'"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputText',
  props: {
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    success: {
      type: String,
      default: '',
    },
    showEye: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    showPassword: false,
  }),

  computed: {
    inputType() {
      if (this.type === 'password' && this.showEye) {
        return this.showPassword ? 'text' : 'password';
      }
      return this.type;
    },

    model: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    clickHandler() {
      this.$refs.input.focus();
    },

  },
};
</script>
